var map = {
	"./CircleShape/Attr": [
		4929,
		824,
		374
	],
	"./Group/Attr": [
		2770,
		824,
		981
	],
	"./LineShape/Attr": [
		9147,
		824,
		891
	],
	"./Picture/Attr": [
		1160,
		824,
		443
	],
	"./RectShape/Attr": [
		5792,
		824,
		163
	],
	"./VButton/Attr": [
		1,
		824,
		318
	],
	"./VChart/Attr": [
		5893,
		824,
		344,
		442
	],
	"./VTable/Attr": [
		2219,
		824,
		512
	],
	"./VText/Attr": [
		322,
		824,
		69
	],
	"./svgs/SVGStar/Attr": [
		5066,
		824,
		677
	],
	"./svgs/SVGTriangle/Attr": [
		3115,
		824,
		384
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1302;
module.exports = webpackAsyncContext;